import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex w-full p-4 space-x-2 bg-primary-50 rounded-2xl mb-7"
}
const _hoisted_3 = { class: "flex flex-wrap justify-between w-full space-y-2 lg:flex-nowrap lg:space-y-0" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold text-darkgray-800" }, "Pending medical questionnaire", -1)
const _hoisted_6 = { class: "text-sm text-darkgray-800" }
const _hoisted_7 = { class: "flex flex-wrap space-y-1 border-b text-darkgray-900 pb-7 mb-7 border-gray-40 lg:space-y-0" }
const _hoisted_8 = { class: "w-full lg:w-1/2" }
const _hoisted_9 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Date Booked")
], -1)
const _hoisted_11 = { class: "col-span-1 text-right" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Time Booked")
], -1)
const _hoisted_14 = { class: "col-span-1 text-right" }
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = { class: "w-full lg:w-1/2 lg:pl-12" }
const _hoisted_17 = { class: "grid grid-cols-2 gap-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Schedule Logs")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-primary-500" }, "Show", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Medical questionnaire")
], -1)
const _hoisted_22 = { class: "col-span-1 text-right" }
const _hoisted_23 = { class: "flex items-center space-x-3 mb-7" }
const _hoisted_24 = {
  key: 1,
  class: "flex flex-wrap"
}
const _hoisted_25 = { class: "w-full lg:w-1/2" }
const _hoisted_26 = { class: "lg:pb-7 mb-7 lg:border-b lg:border-gray-40" }
const _hoisted_27 = { class: "pl-5 list-disc" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("li", null, "N/A", -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "hidden mt-12 lg:flex" }
const _hoisted_33 = { class: "w-full lg:w-1/2 lg:pl-12" }
const _hoisted_34 = { class: "rounded-[10px] bg-white py-7 px-5 text-darkgray-900" }
const _hoisted_35 = { class: "grid grid-cols-12 gap-2.5 border-b border-gray-40 pb-4 mb-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Branch")
], -1)
const _hoisted_37 = { class: "col-span-8 text-right" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package"),
  /*#__PURE__*/_createElementVNode("p", { class: "pl-5 font-bold" }, "Add-on")
], -1)
const _hoisted_39 = { class: "col-span-8 text-right" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, "N/A", -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Date")
], -1)
const _hoisted_45 = { class: "col-span-8 text-right" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Time")
], -1)
const _hoisted_47 = { class: "col-span-8 text-right" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package Fee")
], -1)
const _hoisted_49 = { class: "col-span-8 text-right" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Misc. Fees")
], -1)
const _hoisted_51 = { class: "col-span-8 text-right" }
const _hoisted_52 = {
  key: 0,
  class: "grid grid-cols-12 gap-2.5 text-primary-500"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, "Total")
], -1)
const _hoisted_54 = { class: "col-span-6 text-right" }
const _hoisted_55 = { class: "text-xl font-bold" }
const _hoisted_56 = { class: "flex mt-12 lg:hidden" }
const _hoisted_57 = {
  key: 2,
  class: "min-h-[calc(100vh-500px)]"
}
const _hoisted_58 = {
  key: 0,
  class: "grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-6"
}
const _hoisted_59 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-6"
}

import PortalLayout from '@/layouts/PortalLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import TestResultCard from '@/views/dashboard/test-results/TestResultCard.vue';

import { ChevronLeftIcon, ExclamationCircleIcon } from "@heroicons/vue/24/outline";
import { useRouter, useRoute } from 'vue-router';

import { ref, onMounted } from 'vue';

import patient from "@/classes/UserData";
import TestResults from "@/classes/TestResults";

import { format } from 'date-fns';
import { formatter } from '@/helpers/NumberHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref()
const appointment = ref()
const packageFee = ref(0);
const riderFee = ref(0);
const bookingId = ref(route.params.id as unknown as string);
const laboratoryId = ref(route.query.laboratory_id as unknown as string);
const testResult = ref({})
const testResultFile = ref(null);
const sampleBase64 = ref(null);

const tabSelected = ref('Information');

const calculatePackageFee = () => {
    if(appointment.value.package_details.length > 0) {
        appointment.value.package_details.forEach(packageDetail => {
            packageDetail.trans_line.forEach(trans_line => {
                packageFee.value += trans_line.price * trans_line.qty;
            });
        });
    }
}

const calculateRiderFee = () => {
    if(appointment.value.other_charges_details.length > 0) {
        appointment.value.other_charges_details.forEach(otherCharges => {
            otherCharges.trans_line.forEach(trans_line => {
                riderFee.value += trans_line.price * trans_line.qty;
            });
        });
    }
}

const fetchSelectedAppointment = () => {
    loader.value = true
    
    patient.getSelectedAppointment(bookingId.value)
        .then((result: any) => {
            loader.value = false;
            appointment.value = result.data.response;

            if(appointment.value) {
                calculatePackageFee();
                calculateRiderFee();

                // laboratoryId.value = appointment.value.laboratory_results.length > 0 ? appointment.value.laboratory_results[0].laboratory_id : null;
                // if(laboratoryId.value) {
                //     getSelectedTestResults();
                // }
            } else if(result.data.response.result_status == 500) {
                showError.value = true;
                errorMsg.value = "Something went wrong. Please try again later";
            }
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const getSelectedTestResults = () => {
    loader.value = true
    
    patient.getSelectedTestResults(laboratoryId.value)
        .then((result: any) => {
            loader.value = false;
            testResult.value = result.data.response;

            // getSampleBase64Pdf();
            setTimeout(() => {
                convertBase64ToPdf();
            }, 100)
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const viewTestResult = (laboratory_id:string) => {
 
    loader.value = true

    TestResults.view(laboratory_id)
        .then(({data}) => {
            loader.value = false

            const decodedString = atob(data.response.lab_result_base_64);
            const uint8Array = Uint8Array.from([...decodedString].map(char => char.charCodeAt(0)));
            const blob = new Blob([uint8Array], { type: 'application/pdf' });
            const testResultFile = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = testResultFile;
            link.target = '_blank';
            link.click();

        })
        .catch((err) => {
            loader.value = false
            if(err.response.status == 401) {
                window.location.replace('/login')
            }
        })


}

const getSampleBase64Pdf = () => {

    const xhr = new XMLHttpRequest();
      xhr.open('GET', '/assets/file/sampleBase64.txt', true);
      xhr.onload = () => {
        if (xhr.readyState === xhr.DONE && xhr.status === 200) {
            sampleBase64.value = xhr.responseText;
        }
      };
      xhr.send();

}

const convertBase64ToPdf = () => {
    // const decodedString = atob(testResult.value.lab_result_base_64 ? testResult.value.lab_result_base_64 : sampleBase64.value);

    if(testResult.value.lab_result_base_64) {
        const decodedString = atob(testResult.value.lab_result_base_64);
        const uint8Array = Uint8Array.from([...decodedString].map(char => char.charCodeAt(0)));
        const blob = new Blob([uint8Array], { type: 'application/pdf' });
        testResultFile.value = URL.createObjectURL(blob);
    }
}

const viewMedicalQuestionnaire = (booking_id: number) => {
    router.push('/medical-questionnaire/' + booking_id)
}

const viewScheduleLogs = (booking_type: string) => {
    if(booking_type == 'Individual') {
        window.location.assign(`/schedule-logs/${appointment.value.booking_id}?booking_type=${booking_type}`);
    } else {
        window.location.assign(`/schedule-logs/${appointment.value.corporate_booking_id}?booking_type=${booking_type}&booking_id_of_coporate_booking=${appointment.value.booking_id}`);
    }
}

const backToAppointment = () => {
    window.location.replace('appointment')
}

onMounted(() => { 
    fetchSelectedAppointment()
})


return (_ctx: any,_cache: any) => {
  return (appointment.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(PortalLayout, {
          title: appointment.value.package_name || 'TBA',
          "hide-notification": true
        }, {
          fields: _withCtx(() => []),
          default: _withCtx(() => [
            (!appointment.value.medical_questionnaire)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_unref(ExclamationCircleIcon), { class: "flex-shrink-0 w-6 h-6 text-orange-600" }),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _hoisted_5,
                      _createElementVNode("p", _hoisted_6, "Please fill up your medical questionnaire before your appointment on " + _toDisplayString(_unref(format)(new Date(appointment.value.booking_date ), 'LLLL dd, yyyy')) + ".", 1)
                    ]),
                    _createElementVNode("p", {
                      class: "self-center font-bold cursor-pointer text-primary-500 whitespace-nowrap",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/medical-questionnaire/' + appointment.value.booking_id)))
                    }, "Fill Up Now")
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(format)(new Date(appointment.value.booking_date ), 'LLLL dd, yyyy')), 1)
                  ]),
                  (appointment.value.booking_type == 'Individual')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("p", _hoisted_15, _toDisplayString(appointment.value.booking_start_time ?
                                        new Date(appointment.value.booking_start_time).toLocaleTimeString([], { timeZone: 'UTC', hour: '2-digit', minute:'2-digit' }) :
                                        'TBA') + " - " + _toDisplayString(appointment.value.booking_end_time ?
                                        new Date(appointment.value.booking_end_time).toLocaleTimeString([], { timeZone: 'UTC', hour: '2-digit', minute:'2-digit' }) :
                                        'TBA'), 1)
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (viewScheduleLogs(appointment.value.booking_type))),
                    class: "col-span-1 text-right cursor-pointer"
                  }, _hoisted_20),
                  (appointment.value.medical_questionnaire)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _hoisted_21,
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("p", {
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (viewMedicalQuestionnaire(appointment.value.booking_id))),
                            class: "font-bold cursor-pointer text-primary-500"
                          }, "View")
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["px-5 py-2 text-sm font-bold leading-loose transition rounded-3xl", tabSelected.value == 'Information' ? 'bg-primary-500 text-white' : 'bg-zinc-40 text-primary-500 hover:bg-primary-500 hover:text-white']),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (tabSelected.value = 'Information'))
              }, " Information ", 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["px-5 py-2 text-sm font-bold leading-loose transition rounded-3xl", tabSelected.value == 'Test Results' ? 'bg-primary-500 text-white' : 'bg-zinc-40 text-primary-500 hover:bg-primary-500 hover:text-white']),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (tabSelected.value = 'Test Results'))
              }, " Test Results ", 2)
            ]),
            (tabSelected.value == 'Information')
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("ul", _hoisted_27, [
                        (appointment.value.package_details.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointment.value.package_details[0].trans_line, (service) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: service.package_id
                                }, [
                                  _createElementVNode("li", null, _toDisplayString(service.items.description), 1)
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("a", {
                        onClick: _withModifiers(backToAppointment, ["prevent"]),
                        class: "flex items-center font-bold cursor-pointer text-primary-500"
                      }, [
                        _createVNode(_unref(ChevronLeftIcon), { class: "w-4 h-4 mr-2" }),
                        _createTextVNode(" Go back ")
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("p", null, _toDisplayString(appointment.value.branch_name), 1)
                        ]),
                        _hoisted_38,
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("p", null, _toDisplayString(appointment.value.package_name), 1),
                          (appointment.value.other_charges_details.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointment.value.other_charges_details, (other_charge) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: other_charge.transaction_code
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(other_charge.trans_line, (rider) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: rider.item_id
                                      }, [
                                        _createElementVNode("p", null, _toDisplayString(rider.items?.description), 1)
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
                        ]),
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("p", null, _toDisplayString(_unref(format)(new Date(appointment.value.booking_date ), 'LLLL dd, yyyy')), 1)
                        ]),
                        _hoisted_46,
                        _createElementVNode("div", _hoisted_47, _toDisplayString(appointment.value.booking_start_time ?
                                    new Date(appointment.value.booking_start_time).toLocaleTimeString([], { timeZone: 'UTC', hour: '2-digit', minute:'2-digit' }) :
                                    'TBA') + " - " + _toDisplayString(appointment.value.booking_end_time ?
                                    new Date(appointment.value.booking_end_time).toLocaleTimeString([], { timeZone: 'UTC', hour: '2-digit', minute:'2-digit' }) :
                                    'TBA'), 1),
                        (appointment.value.booking_type != 'Corporate')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_48,
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("p", null, _toDisplayString(_unref(formatter).format(packageFee.value)), 1)
                              ]),
                              _hoisted_50,
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("p", null, _toDisplayString(_unref(formatter).format(riderFee.value)), 1)
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      (appointment.value.booking_type != 'Corporate')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            _hoisted_53,
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("p", _hoisted_55, _toDisplayString(_unref(formatter).format(appointment.value.total_fee)), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(backToAppointment, ["prevent"]),
                      class: "flex items-center font-bold cursor-pointer text-primary-500"
                    }, [
                      _createVNode(_unref(ChevronLeftIcon), { class: "w-4 h-4 mr-2" }),
                      _createTextVNode(" Go back ")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (tabSelected.value != 'Information')
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  (appointment.value?.laboratory_results.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appointment.value?.laboratory_results, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createVNode(TestResultCard, {
                              badge: false,
                              item: item,
                              onClick: ($event: any) => (viewTestResult(item.laboratory_id))
                            }, null, 8, ["item", "onClick"])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_59, " No results "))
                ]))
              : _createCommentVNode("", true),
            (loader.value)
              ? (_openBlock(), _createBlock(PageLoader, { key: 3 }))
              : _createCommentVNode("", true),
            _createVNode(ErrorModal, {
              width: "w-[548px]",
              title: "Error",
              "action-text": "Close",
              "cancel-text": "Go back",
              show: showError.value,
              onClose: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
              onConfirm: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false))
            }, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString(errorMsg.value), 1)
              ]),
              _: 1
            }, 8, ["show"])
          ]),
          _: 1
        }, 8, ["title"])
      ]))
    : _createCommentVNode("", true)
}
}

})